import { Injectable } from '@angular/core';
import * as THREE from 'three';
import { ModelLoaderService } from '../services/index';
@Injectable({
  providedIn: 'root',
})
export class LaneBulbService {
  private _laneBulb: Map<string, any> = new Map<string, any>();

  constructor(private _modelLoaderService: ModelLoaderService) {}

  /**
   * Sets lane bulb red
   * @param laneName
   */
  setLaneBulbRed(laneName: string) {
    this._laneBulb = this._modelLoaderService.getLaneBulb();
    if (this._laneBulb.get(laneName) !== undefined) {
      const bulb = this._laneBulb.get(laneName);
      bulb.material.color = new THREE.Color(0xff0a0a);
    }
  }
  /**
   * Sets lane bulb grey
   * @param laneName
   */
  setLaneBulbGrey(laneName: string) {
    this._laneBulb = this._modelLoaderService.getLaneBulb();
    if (this._laneBulb.get(laneName) !== undefined) {
      const bulb = this._laneBulb.get(laneName);
      bulb.material.color = new THREE.Color(0xffffff);
    }
  }
}
